import script from "./FormularioConfiguracaoCobranca.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioConfiguracaoCobranca.vue?vue&type=script&setup=true&lang=js"

import "./FormularioConfiguracaoCobranca.vue?vue&type=style&index=0&id=44340188&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44340188"]])

export default __exports__